module.exports = __webpack_public_path__ + "media/images/getting-started/instagram-edit-profile-4f9e3cd2300f9b43ddb218e494c218f9.png";